import GenericModel from 'js/models/generic.model';

export default GenericModel.extend({
    defaults: {
        address: '',
        city: '',
        company: '',
        companyDetailsId: 1,
        contactPhone: '',
        country: '',
        email: '',
        postalCode: '',
        privacyPolicyURL: '',
    },
    idAttribute: 'companyDetailsId',
    urlRoot: '/CampaignCloud/CompanyDetails'
});